/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OrganizationUnitLeaderCreate,
  OrganizationUnitLeaderCreateResponse,
  OrganizationUnitLeaderIndexResponse,
  OrganizationUnitLeaderUpdate,
  OrganizationUnitLeaderUpdateResponse,
} from '../models';
import {
    OrganizationUnitLeaderCreateFromJSON,
    OrganizationUnitLeaderCreateToJSON,
    OrganizationUnitLeaderCreateResponseFromJSON,
    OrganizationUnitLeaderCreateResponseToJSON,
    OrganizationUnitLeaderIndexResponseFromJSON,
    OrganizationUnitLeaderIndexResponseToJSON,
    OrganizationUnitLeaderUpdateFromJSON,
    OrganizationUnitLeaderUpdateToJSON,
    OrganizationUnitLeaderUpdateResponseFromJSON,
    OrganizationUnitLeaderUpdateResponseToJSON,
} from '../models';

export interface CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversGetRequest {
    organizationUnitId: number;
    at?: Date | null;
    page?: number;
    perPage?: number;
}

export interface CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdDeleteRequest {
    organizationUnitId: number;
    id: string;
}

export interface CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdPutRequest {
    organizationUnitId: number;
    id: string;
    body?: OrganizationUnitLeaderUpdate;
}

export interface CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversPostRequest {
    organizationUnitId: number;
    body?: OrganizationUnitLeaderCreate;
}

export interface CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersGetRequest {
    organizationUnitId: number;
    at?: Date | null;
    page?: number;
    perPage?: number;
}

export interface CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdDeleteRequest {
    organizationUnitId: number;
    id: string;
}

export interface CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdPutRequest {
    organizationUnitId: number;
    id: string;
    body?: OrganizationUnitLeaderUpdate;
}

export interface CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersPostRequest {
    organizationUnitId: number;
    body?: OrganizationUnitLeaderCreate;
}

/**
 * 
 */
export class OrganizationUnitLeaderApi extends runtime.BaseAPI {

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversGetRaw(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrganizationUnitLeaderIndexResponse>>> {
        if (requestParameters.organizationUnitId === null || requestParameters.organizationUnitId === undefined) {
            throw new runtime.RequiredError('organizationUnitId','Required parameter requestParameters.organizationUnitId was null or undefined when calling companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.at !== undefined) {
            queryParameters['at'] = (requestParameters.at as any).toISOString().substr(0,10);
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/organization_units/{organization_unit_id}/organization_unit_financial_approvers`.replace(`{${"organization_unit_id"}}`, encodeURIComponent(String(requestParameters.organizationUnitId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrganizationUnitLeaderIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversGet(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrganizationUnitLeaderIndexResponse>> {
        const response = await this.companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdDeleteRaw(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.organizationUnitId === null || requestParameters.organizationUnitId === undefined) {
            throw new runtime.RequiredError('organizationUnitId','Required parameter requestParameters.organizationUnitId was null or undefined when calling companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/organization_units/{organization_unit_id}/organization_unit_financial_approvers/{id}`.replace(`{${"organization_unit_id"}}`, encodeURIComponent(String(requestParameters.organizationUnitId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdDelete(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdPutRaw(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationUnitLeaderUpdateResponse>> {
        if (requestParameters.organizationUnitId === null || requestParameters.organizationUnitId === undefined) {
            throw new runtime.RequiredError('organizationUnitId','Required parameter requestParameters.organizationUnitId was null or undefined when calling companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdPut.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/organization_units/{organization_unit_id}/organization_unit_financial_approvers/{id}`.replace(`{${"organization_unit_id"}}`, encodeURIComponent(String(requestParameters.organizationUnitId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationUnitLeaderUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationUnitLeaderUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdPut(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationUnitLeaderUpdateResponse> {
        const response = await this.companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversPostRaw(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationUnitLeaderCreateResponse>> {
        if (requestParameters.organizationUnitId === null || requestParameters.organizationUnitId === undefined) {
            throw new runtime.RequiredError('organizationUnitId','Required parameter requestParameters.organizationUnitId was null or undefined when calling companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/organization_units/{organization_unit_id}/organization_unit_financial_approvers`.replace(`{${"organization_unit_id"}}`, encodeURIComponent(String(requestParameters.organizationUnitId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationUnitLeaderCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationUnitLeaderCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversPost(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationUnitLeaderCreateResponse> {
        const response = await this.companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitFinancialApproversPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersGetRaw(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrganizationUnitLeaderIndexResponse>>> {
        if (requestParameters.organizationUnitId === null || requestParameters.organizationUnitId === undefined) {
            throw new runtime.RequiredError('organizationUnitId','Required parameter requestParameters.organizationUnitId was null or undefined when calling companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.at !== undefined) {
            queryParameters['at'] = (requestParameters.at as any).toISOString().substr(0,10);
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/organization_units/{organization_unit_id}/organization_unit_leaders`.replace(`{${"organization_unit_id"}}`, encodeURIComponent(String(requestParameters.organizationUnitId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrganizationUnitLeaderIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersGet(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrganizationUnitLeaderIndexResponse>> {
        const response = await this.companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdDeleteRaw(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.organizationUnitId === null || requestParameters.organizationUnitId === undefined) {
            throw new runtime.RequiredError('organizationUnitId','Required parameter requestParameters.organizationUnitId was null or undefined when calling companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/organization_units/{organization_unit_id}/organization_unit_leaders/{id}`.replace(`{${"organization_unit_id"}}`, encodeURIComponent(String(requestParameters.organizationUnitId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdDelete(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdPutRaw(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationUnitLeaderUpdateResponse>> {
        if (requestParameters.organizationUnitId === null || requestParameters.organizationUnitId === undefined) {
            throw new runtime.RequiredError('organizationUnitId','Required parameter requestParameters.organizationUnitId was null or undefined when calling companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdPut.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/organization_units/{organization_unit_id}/organization_unit_leaders/{id}`.replace(`{${"organization_unit_id"}}`, encodeURIComponent(String(requestParameters.organizationUnitId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationUnitLeaderUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationUnitLeaderUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdPut(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationUnitLeaderUpdateResponse> {
        const response = await this.companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersPostRaw(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationUnitLeaderCreateResponse>> {
        if (requestParameters.organizationUnitId === null || requestParameters.organizationUnitId === undefined) {
            throw new runtime.RequiredError('organizationUnitId','Required parameter requestParameters.organizationUnitId was null or undefined when calling companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/organization_units/{organization_unit_id}/organization_unit_leaders`.replace(`{${"organization_unit_id"}}`, encodeURIComponent(String(requestParameters.organizationUnitId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationUnitLeaderCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationUnitLeaderCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersPost(requestParameters: CompanySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationUnitLeaderCreateResponse> {
        const response = await this.companySpacesOrganizationUnitsOrganizationUnitIdOrganizationUnitLeadersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
